import { filter } from 'lodash';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import { useState, useEffect } from 'react';
import {
  Card,
  Table,
  TableRow,
  TableBody,
  TableCell,
  Container,
  TableContainer,
  TablePagination,
  IconButton,
  styled
} from '@material-ui/core';

import moment from 'moment';
import DeleteForeverIcon from '@material-ui/icons/DeleteForever';
import EditIcon from '@material-ui/icons/Edit';
import { baseUrl } from '../../utils/constants';
import Scrollbar from '../Scrollbar';
import SearchNotFound from '../SearchNotFound';
import { ClientListHead } from '../_dashboard/clients';
import Controls from '../controls/Controls';
import SsbProcessLineEdit from './SsbProcessLineEdit';

const StyledTableRow = styled(TableRow)(({ theme }) => ({
  '&:nth-of-type(odd)': {
    backgroundColor: theme.palette.action.hover
  },
  '&:last-child td, &:last-child th': {
    border: 0
  }
}));

const TABLE_HEAD = [
  { id: 'studid', label: 'Member ID', alignRight: true },
  { id: 'studidno', label: 'Payee Code', alignRight: true },
  { id: 'typ', label: 'Reference', alignRight: true },
  { id: 'description', label: 'Id Number', alignRight: false },
  { id: 'actions', label: 'Action', alignRight: false },
  { id: 'amount', label: 'Amount (Cents)', alignRight: true },
  { id: 'fromdat', label: 'Date From', alignRight: false },
  { id: 'todat', label: 'Date To', alignRight: false },
  { id: 'errsympt', label: 'Error Symptoms', alignRight: false },
  { id: 'asd', label: '' },
  { id: 'assd', label: '' }
];

function descendingComparator(a, b, orderBy) {
  if (b[orderBy] < a[orderBy]) {
    return -1;
  }
  if (b[orderBy] > a[orderBy]) {
    return 1;
  }
  return 0;
}

function getComparator(order, orderBy) {
  return order === 'desc'
    ? (a, b) => descendingComparator(a, b, orderBy)
    : (a, b) => -descendingComparator(a, b, orderBy);
}

function applySortFilter(array, comparator, query) {
  const stabilizedThis = array.map((el, index) => [el, index]);
  stabilizedThis.sort((a, b) => {
    const order = comparator(a[0], b[0]);
    if (order !== 0) return order;
    return a[1] - b[1];
  });
  if (query) {
    return filter(
      array,
      (_doc) => _doc.documentType.toLowerCase().indexOf(query.toLowerCase()) !== -1
    );
  }
  return stabilizedThis.map((el) => el[0]);
}

export default function SsbProcessDetails(id) {
  const [page, setPage] = useState(0);
  const [order, setOrder] = useState('asc');
  const [loading, setLoading] = useState(false);
  const [selected, setSelected] = useState([]);
  const [dataList, setDataList] = useState([]);
  const [orderBy, setOrderBy] = useState('documentType');
  const [filterName, setFilterName] = useState('');
  const [rowsPerPage, setRowsPerPage] = useState(8);
  const [openPopup, setOpenPopup] = useState(false);
  const [currentRefId, setRefId] = useState(0);
  const [notify, setNotify] = useState({ isOpen: false, message: '', type: 'success' });
  const [confirmDialog, setConfirmDialog] = useState({
    isOpen: false,
    title: '',
    subTitle: '',
    heading: '',
    color: '#000000'
  });
  const navigate = useNavigate();
  // const classes = useStyles();

  useEffect(() => {
    getSsbSubDetails();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === 'asc';
    setOrder(isAsc ? 'desc' : 'asc');
    setOrderBy(property);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const getSsbSubDetails = async () => {
    console.log('id ipapa', id);
    setLoading(true);
    await axios(`${baseUrl}/api/client/GetSsbDetailsRpt?refId=${id.processNo}`).then(
      (res) => {
        setLoading(false);
        console.log('returned GetTermBills', res);
        setDataList(res.data.result);
      },
      (error) => {
        setLoading(false);
        alert(`failed here ${{ error }}`);
      }
    );
  };

  const handleLineDelete = async (e) => {
    console.log('e here', e.row.refId);
    if (e === '') {
      return;
    }
    setConfirmDialog({
      ...confirmDialog,
      isOpen: false
    });
    setLoading(true);
    await axios.post(`${baseUrl}/api/ssb/deleteSsbSubmissionLine?refId=${e.row.refId}`).then(
      (result) => {
        setLoading(false);
        if (result.replyStatus === 1) {
          notifyPopup(`Error in Deleting SSB Record!: ${result.replyMessage}`, 'error');
        } else {
          getSsbSubDetails();
          notifyPopup(`Ssb Record Deleted Successfully!`, 'success');
        }
      },
      (error) => {
        notifyPopup(`Error in Deleting Import Line!: ${error}`, 'error');
      }
    );
  };

  const handleEditView = (e) => {
    setRefId(e.row.refId);
    setOpenPopup(true);
  };

  const handleLoadingClose = () => {
    setLoading(false);
  };

  const convertDeductionType = (e) => {
    switch (e) {
      case 0:
        return 'n';
      case 1:
        return 'c';
      case 2:
        return 'd';
      default:
        return 'n';
    }
  };

  const closePopup = () => {
    setOpenPopup(false);
  };

  const notifyPopup = (notifyMessage, notifyType) => {
    setNotify({
      isOpen: true,
      message: `${notifyMessage}`,
      type: `${notifyType}`
    });
  };

  const emptyRows = page > 0 ? Math.max(0, (1 + page) * rowsPerPage - dataList.length) : 0;

  const filteredUsers = applySortFilter(dataList, getComparator(order, orderBy), filterName);

  const isUserNotFound = filteredUsers.length === 0;

  return (
    <Container>
      <Card>
        <Scrollbar>
          <TableContainer sx={{ minWidth: 800 }}>
            <Table size="small" aria-label="a dense table">
              <ClientListHead
                order={order}
                orderBy={orderBy}
                headLabel={TABLE_HEAD}
                rowCount={dataList.length}
                numSelected={selected.length}
                onRequestSort={handleRequestSort}
                // onSelectAllClick={handleSelectAllClick}
              />
              <TableBody>
                {filteredUsers
                  .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                  .map((row) => {
                    /* eslint-disable camelcase */
                    const {
                      id,
                      refId,
                      status,
                      payeeCode,
                      employeeNumber,
                      symptoms,
                      idNumber,
                      fromDate,
                      toDate,
                      policyRefNum,
                      amountInCents,
                      transactionType
                    } = row;
                    const isItemSelected = selected.indexOf(id) !== -1;

                    return (
                      <StyledTableRow
                        hover
                        key={id}
                        tabIndex={-1}
                        role="checkbox"
                        selected={isItemSelected}
                        aria-checked={isItemSelected}
                      >
                        <TableCell padding="checkbox" />

                        <TableCell align="right">{employeeNumber}</TableCell>
                        <TableCell align="right">{payeeCode}</TableCell>
                        <TableCell align="right">{policyRefNum}</TableCell>
                        <TableCell align="left">{idNumber}</TableCell>
                        <TableCell align="left">{convertDeductionType(transactionType)}</TableCell>
                        <TableCell align="right">{amountInCents.toFixed(0)}</TableCell>
                        <TableCell component="th" scope="row" padding="none">
                          {moment(fromDate).isValid() ? moment(fromDate).format('YYYY-MM-DD') : ''}
                        </TableCell>
                        <TableCell component="th" scope="row" padding="none">
                          {moment(toDate).isValid() ? moment(toDate).format('YYYY-MM-DD') : ''}
                        </TableCell>
                        <TableCell align="left">{symptoms}</TableCell>
                        <TableCell align="right">
                          <IconButton onClick={() => handleEditView({ row })}>
                            <EditIcon sx={{ color: '#03a9f4' }} />
                          </IconButton>
                        </TableCell>
                        <TableCell align="right">
                          {status === 0 && (
                            <IconButton
                              onClick={() =>
                                setConfirmDialog({
                                  isOpen: true,
                                  title: 'Are you sure you want to Delete SSB Record Line',
                                  subTitle: "You can't undo this action",
                                  heading: 'Delete SSB Record',
                                  color: '#00000',
                                  onConfirm: () => {
                                    handleLineDelete({ row });
                                  }
                                })
                              }
                            >
                              <DeleteForeverIcon sx={{ color: '#f44336' }} />
                            </IconButton>
                          )}
                        </TableCell>
                      </StyledTableRow>
                    );
                  })}
                {emptyRows > 0 && (
                  <TableRow style={{ height: 53 * emptyRows }}>
                    <TableCell colSpan={6} />
                  </TableRow>
                )}
              </TableBody>
              {isUserNotFound && (
                <TableBody>
                  <TableRow>
                    <TableCell align="center" colSpan={6} sx={{ py: 3 }}>
                      <SearchNotFound searchQuery={filterName} />
                    </TableCell>
                  </TableRow>
                </TableBody>
              )}
            </Table>
          </TableContainer>
          <Controls.Notification notify={notify} setNotify={setNotify} />
          <Controls.ConfirmDialog
            confirmDialog={confirmDialog}
            setConfirmDialog={setConfirmDialog}
          />
          <Controls.Popup title="Edit SSB Line" openPopup={openPopup} setOpenPopup={setOpenPopup}>
            <SsbProcessLineEdit closePopup={closePopup} refId={currentRefId} />
          </Controls.Popup>
        </Scrollbar>

        <TablePagination
          sx={{
            backgroundColor: 'black',
            color: 'white',
            size: 'small'
          }}
          rowsPerPageOptions={[8, 16, 24]}
          component="div"
          count={dataList.length}
          rowsPerPage={rowsPerPage}
          page={page}
          onPageChange={handleChangePage}
          onRowsPerPageChange={handleChangeRowsPerPage}
        />
      </Card>
    </Container>
  );
}
